import React, { useEffect, useRef, useState } from "react";
import Dashboardmenus from "./Dashboardmenus";
import hotkeys from "../../../images/Keyboardhotkey.png";
import { Link, useNavigate } from "react-router-dom";
import { authcallApi, authcallApipost } from "../../common/API/Api";
import { useTranslation } from "react-i18next";
import buyicon from "../../../images/buy-icon.svg";
import { useNotification } from "../../common/Notification";
import {
  LanguageSelector,
  Settings,
  TimezoneSelector,
} from "./commonmodal/Commondropdowns";
import CommonDropdown from "../../common/CommonDropdown";
import { useModal } from "../../common/Collapsfunction";
import { SetSound } from "../../../store/soundSlice";
import { useDispatch } from "react-redux";
import info from "../../../images/info.svg";
import { getBaseUrl } from "../../common/BaseUrl";
import sellicon from "../../../images/sell-icon.svg";
import Pagination from "./commonmodal/Pagination";
import Commonloader from "../../common/Commonloader";
const Setting = (props) => {
  const { showNotification } = useNotification();
  const { setSoundEnabled, soundEnabled } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { modalRefs, openModal } = useModal();
  const dispatch = useDispatch();
  let base_url = getBaseUrl();
  const [classNameicMode, setClassNameicMode] = useState(false);
  const [showtooltip, setShowtooltip] = useState(false);
  const [loginsection, setLoginsection] = useState([]);
  const [loginhistory, setLoinhistory] = useState([]);
  const [searchpopup, setSearchpopup] = useState(false);
  const [loadingactive, setLoadingactive] = useState(true);
  const [loadinglogin, setLoadinglogin] = useState(true);
  const [currentPageactive, setCurrentPageactive] = useState(1);
  const [totalPagesactive, setTotlepagesactive] = useState();
  const [itemsPerPageactive, setItemperpageactive] = useState();
  const [updatetimezone, setUpdateTimezone] = useState(null);
  const [soundbalance, setSoundbalance] = useState(false);
  const [userdata, setUserdata] = useState();
  const [deleteresion, setDeleteresion] = useState("");
  const [deletresiontext, setDeleteresiontext] = useState("");
  const [deletetext, setDeletetext] = useState("");
  const [settingloader, setSettingloader] = useState({
    default: false,
    classic: false,
  });
  const [socialTradingSettings, setSocialTradingSettings] = useState({
    // displaySocialTrades: true,
    watchingCopiedTrades: false,
    hideCopyingStatistics: true,
    hideWatchingTrading: true,
    showOnlyWatchedTraders: true,
  });
  const settingLabels = {
    // displaySocialTrades: "Display social trades",
    watchingCopiedTrades: t("Watching copied trades"),
    hideCopyingStatistics: t("Hide copying and statistics of my profile"),
    hideWatchingTrading: t("Hide watching of my trading"),
    showOnlyWatchedTraders: t("Show only watched traders"),
  };
  const [activekeys, setActivekeys] = useState(false);
  const [passvalidmessage, setPassvalidmessage] = useState();
  const [password, setPassword] = useState();
  const [showpassword, setShowpassword] = useState({
    password: false,
    confirmpassword: false,
    new_password: false,
  });
  const deleteresiondata = [
    "I would like to close my duplicate account",
    "The service is too confusing for me to understand",
    "I find it difficult to add funds or withdraw from my account",
    "I would like to take a break from trading and maybe resume later",
    "I need to close this account to be able to create a new one under a partner's link",
    "I am experiencing difficulties while trading that I could not manage",
    "I am lacking certain platform features or my account is somewhat limited",
    "My trading was not successful and I wish to stop",
    "Other reason (Please specify)",
  ];
  const reasonMessages = {
    "I would like to close my duplicate account": {
      text: "Thank you for closing a duplicate account as it is not allowed to have more than one trading account according with the Public Offer Agreement.",
    },

    "The service is too confusing for me to understand": {
      text: "We're sorry to hear that. Please find the extensive manual on the platform here. Whenever you're having any questions - do not hesitate to contact our {{support}}.",
    },

    "I find it difficult to add funds or withdraw from my account": {
      text: "We're sorry to hear that you experienced difficulties while performing financial operations. Please do not hesitate to contact our {{support}} to get assistance. We will be happy to find a suitable solution for you.",
    },

    "I would like to take a break from trading and maybe resume later": {
      text: "We totally understand your feelings and support you. Feel free to come back and resume your trading activity - we have a few special gifts just for you!",
    },

    "I need to close this account to be able to create a new one under a partner's link":
      {
        text: "",
      },

    "I am experiencing difficulties while trading that I could not manage": {
      text: "We're sorry to hear that you experienced any difficulties. Do not hesitate to contact our {{support}} and we will be happy to assist you.",
    },

    "I am lacking certain platform features or my account is somewhat limited":
      {
        text: "We're sorry to hear that you experienced any difficulties. Do not hesitate to contact our {{support}} and we will be happy to find a solution for you.",
      },

    "My trading was not successful and I wish to stop": {
      text: "We're sorry to hear that your trading was not as successful. Do not hesitate to contact our {{support}} and we will be happy to assist you with trading techniques and strategies and maybe even a few trading advantages.",
    },
  };
  const setuppassword = (key, value) => {
    setPassword((state) => ({
      ...state,
      [key]: value,
    }));
  };
  const passwordvalid = () => {
    if (!password?.current_password) {
      setPassvalidmessage((state) => ({
        ...state,
        current_password: t("Current Password is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        current_password: "",
      }));
    }
    if (!password?.new_password) {
      setPassvalidmessage((state) => ({
        ...state,
        new_password: t("New Password is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        new_password: "",
      }));
    }
    if (!password?.password) {
      setPassvalidmessage((state) => ({
        ...state,
        password: t("Confirm Password is Required"),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        password: "",
      }));
    }

    if (password?.new_password !== password?.password) {
      setPassvalidmessage((state) => ({
        ...state,
        matchpassword: t("Passwords do not match."),
        error: "",
        success: "",
      }));
      return;
    } else {
      setPassvalidmessage((state) => ({
        ...state,
        matchpassword: "",
      }));
    }
    updatepassword(password);
  };
  const updatepassword = async (passworddata) => {
    let userpass = { ...passworddata };
    delete userpass?.new_password;
    try {
      const formData = new FormData();
      for (let key in userpass) {
        if (userpass.hasOwnProperty(key)) {
          formData.append(key, userpass[key]);
        }
      }
      let postdata = formData;
      let res = await authcallApi(postdata, `api/userpassword`, "POST");
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
        setPassword({
          current_password: "",
          new_password: "",
          password: "",
        });
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const hotkeysset = async (value) => {
    try {
      let postdata = {
        key: "hotkey",
        value: value,
      };
      const formData = new FormData();
      for (let key in postdata) {
        if (postdata.hasOwnProperty(key)) {
          formData.append(key, postdata[key]);
        }
      }
      let res = await authcallApi(formData, `api/setpreference`, "POST");
      if (res?.data?.success) {
        gethotkeys();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gethotkeys = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/preference?key=hotkey`, "GET");
      if (res?.data?.success) {
        setActivekeys(parseInt(res?.data?.value));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    gethotkeys();
  }, []);

  const setupsocialsetting = (key) => {
    setSocialTradingSettings((prev) => {
      const updatedSettings = {
        ...prev,
        [key]: !prev[key],
      };
      socialpreference(updatedSettings);
      setSocialTradingSettings(updatedSettings);
      return updatedSettings;
    });
  };
  const socialpreference = async (value) => {
    try {
      let postdata = {
        key: "SocialTradingSettings",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        console.log(value, "jsonObject");
        // checksocialpreference();
        // setSocialTradingSettings(value);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const checksocialpreference = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=SocialTradingSettings`,
        "GET",
      );
      if (res?.data?.success) {
        if (res?.data?.value) {
          const jsonObject = JSON.parse(res?.data?.value);

          setSocialTradingSettings(jsonObject);
          console.log(jsonObject, "jsonObject");
        } else {
          setSocialTradingSettings({
            // displaySocialTrades: true,
            watchingCopiedTrades: false,
            hideCopyingStatistics: true,
            hideWatchingTrading: true,
            showOnlyWatchedTraders: true,
          });
        }
      } else {
        setSocialTradingSettings({
          // displaySocialTrades: true,
          watchingCopiedTrades: false,
          hideCopyingStatistics: true,
          hideWatchingTrading: true,
          showOnlyWatchedTraders: true,
        });
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    checksocialpreference();
  }, []);
  const getloginsection = async (page) => {
    try {
      setLoadingactive(true);
      let postdata = {
        page: page ? page : 1,
      };
      let res = await authcallApi(
        postdata,
        `api/getloginsessions?page=${postdata?.page}`,
      );
      if (res?.data?.success) {
        setCurrentPageactive(res?.data?.pagination?.current_page);
        setTotlepagesactive(res?.data?.pagination?.total);
        setItemperpageactive(10);
        setLoginsection(res?.data?.sessions);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingactive(false);
    }
  };
  const goToPageactive = (page) => {
  const totalPagesall = Math.ceil(totalPagesactive / itemsPerPageactive);
    if (page < 1 || page > totalPagesall) return;
    setCurrentPageactive(page);
    // if (page === 1) {
    getloginsection(page);
    // }
  };
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date
      .toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };
  const getloginhistory = async () => {
    try {
      setLoadinglogin(true);
      let postdata = {};
      let res = await authcallApi(postdata, `api/getloginactivity`, "GET");
      if (res?.data?.success) {
        setLoinhistory(res?.data?.last_activity);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadinglogin(false);
    }
  };
  useEffect(() => {
    getloginsection();
    getloginhistory();
  }, []);
  const searchprefrence = async (value) => {
    try {
      setSearchpopup(!searchpopup);

      let postdata = {
        key: "searchpopup",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        // getsearchprefrence();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsearchprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=searchpopup`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setSearchpopup(parsedValue);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsearchprefrence();
  }, []);

  const terminatsessions = async (checkall, id) => {
    try {
      let array = [];
      if (checkall == "all") {
        id.forEach((item) => {
          array.push(item?.token_id);
        });
      }
      let postdata = {
        token_id: checkall == "all" ? array : [id],
      };
      let res = await authcallApi(postdata, `api/terminate-sessions`, "POST");
      if (res?.data?.success) {
        getloginsection();
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "Err");
    }
  };
  const setsoundbalancepre = async (value, checksound) => {
    try {
      let data;
      if (checksound) {
        data = value;
      } else {
        data = false;
      }

      let postdata = {
        key: "soundbalance",
        value: JSON.stringify(data),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getsoundbalance();
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const getsoundbalance = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=soundbalance`,
        "GET",
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        setSoundbalance(parsedValue);
        console.log("checksound 1", parsedValue);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsoundbalance();
  }, []);
  const setsettingprefrence = async (
    classNameicMode,
    soundEnabled,
    showtooltip,
  ) => {
    try {
      if (classNameicMode) {
        setSettingloader((state) => ({
          ...state,
          classic: true,
          default: false,
        }));
      } else {
        setSettingloader((state) => ({
          ...state,
          classic: false,
          default: true,
        }));
      }
      let value = {
        tradingbuttion: classNameicMode,
        soundcontrol: soundEnabled,
        tooltip: showtooltip,
      };
      let postdata = {
        key: "chartsetting",
        value: JSON.stringify(value),
      };
      let res = await authcallApipost(postdata, `api/setpreference`, "POST");
      if (res?.data?.success) {
        getsettingprefrence();
        setsoundbalancepre(value?.soundcontrol, value?.soundcontrol);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getsettingprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=chartsetting`,
        "GET",
      );
      if (res?.data?.success) {
        setSettingloader((state) => ({
          ...state,
          classic: false,
          default: false,
        }));
        const parsedValue = JSON.parse(res?.data.value);
        setClassNameicMode(parsedValue?.tradingbuttion);
        setSoundEnabled(parsedValue?.soundcontrol);
        dispatch(SetSound(parsedValue?.soundcontrol));
        setShowtooltip(parsedValue?.tooltip);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    getsettingprefrence();
  }, []);
  const userdetails = async () => {
    try {
      let res = await authcallApi({}, `api/userdetail?type=real`, "GET");
      if (res?.data?.success !== false) {
        setUserdata(res?.data?.data?.user);
      } else {
        console.error("API error:", res.error);
      }
    } catch (err) {
      console.log(err, "error");
    }
  };
  useEffect(() => {
    userdetails();
  }, []);
  const dummydeposit = async (amount) => {
    try {
      let postdata = {
        id: userdata?.id,
        amount: amount,
      };
      let res = await authcallApi(
        postdata,
        `api/add-amount-dummy-user`,
        "POST",
      );
      if (res?.data?.success) {
        showNotification(res?.data?.message, "success");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const [value, setValue] = useState(1);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (inputValue >= 1 || inputValue === "") {
      setValue(inputValue);
    }
  };
  const deleteaccount = async (reason) => {
    try {
      let sendresion;
      if (reason === "Other reason (Please specify)") {
        if (!deletresiontext) {
          setDeletetext("The Please specify field is required");
          return;
        } else {
          setDeletetext("");
        }
        sendresion = deletresiontext;
      } else {
        sendresion = reason;
        setDeletetext("");
      }
      let postdata = { reason: sendresion };
      let res = await authcallApi(postdata, `api/deleteaccount`, "POST");
      if (res?.data?.success) {
        const modalElement = document.getElementById("deletepopupmodal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        modalInstance?.hide();
        localStorage.setItem("token", "");

        navigate(`${base_url}closeaccount`, {
          state: { from: userdata },
        });
        showNotification(res?.data?.message, "success");
        setDeletetext("");
      } else {
        showNotification(res?.data?.message, "error");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    const modalEl = document.getElementById("deletepopupmodal");

    const handleModalHidden = () => {
      setDeleteresion("");
    };
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", handleModalHidden);
    }
    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleModalHidden);
      }
    };
  }, []);
  const handleSupportClick = () => {
    const modalElement = document.getElementById("deletepopupmodal");
    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
    modalInstance?.hide();
    navigate(`${base_url}supportdashboard`, {
      state: { from: "my_requests" },
    });
  };

  return (
    <React.Fragment>
      <Dashboardmenus />
      <div className="dashboard-contentbody">
        <section className="DepositSec">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="withdrawal_form">
                  <div className="cardBox mb-4">
                    <h4 className="card_title">{t("Security")}</h4>
                    <form action="#">
                      <div className="row">
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3 form-group position-relative">
                            <label>{t("Old Password")}</label>
                            <input
                              value={password?.current_password}
                              type={
                                showpassword?.current_password
                                  ? "text"
                                  : "password"
                              }
                              name="password"
                              className={
                                passvalidmessage?.current_password
                                  ? "form-control border-danger"
                                  : "form-control"
                              }
                              placeholder={t("Enter old password")}
                              onChange={(e) =>
                                setuppassword(
                                  "current_password",
                                  e.target.value,
                                )
                              }
                              style={{ paddingRight: "40px" }}
                            />
                            <i
                              onClick={() =>
                                setShowpassword((state) => ({
                                  ...state,
                                  current_password:
                                    !showpassword?.current_password,
                                }))
                              }
                              className={`toggle-password fa-regular fa-fw ${
                                showpassword?.current_password
                                  ? "fa-eye"
                                  : "fa-eye-slash"
                              }`}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: passvalidmessage?.current_password
                                  ? "50%"
                                  : "70%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "rgb(189 189 185)",
                              }}
                            ></i>
                            {passvalidmessage?.current_password ? (
                              <p className="p-0 text-danger">
                                {passvalidmessage?.current_password}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3  position-relative">
                            <label>{t("New Password")}</label>
                            <input
                              value={password?.new_password}
                              type={
                                showpassword?.new_password ? "text" : "password"
                              }
                              name="new_password"
                              className={
                                passvalidmessage?.new_password
                                  ? "form-control border-danger"
                                  : "form-control"
                              }
                              placeholder={t("Enter new password")}
                              onChange={(e) =>
                                setuppassword("new_password", e.target.value)
                              }
                              style={{ paddingRight: "40px" }}
                            />
                            <i
                              onClick={() =>
                                setShowpassword((state) => ({
                                  ...state,
                                  new_password: !showpassword?.new_password,
                                }))
                              }
                              className={`toggle-password fa-regular fa-fw ${
                                showpassword?.new_password
                                  ? "fa-eye"
                                  : "fa-eye-slash"
                              }`}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: passvalidmessage?.new_password
                                  ? "50%"
                                  : "70%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "rgb(189 189 185)",
                              }}
                            ></i>
                            {passvalidmessage?.new_password ? (
                              <p className="p-0 text-danger">
                                {passvalidmessage?.new_password}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="mb-3 position-relative">
                            <label>{t("Confirm New Password")}</label>
                            <input
                              value={password?.password}
                              type={
                                showpassword?.password ? "text" : "password"
                              }
                              name="new_password"
                              className={
                                passvalidmessage?.password
                                  ? "form-control border-danger"
                                  : "form-control"
                              }
                              placeholder={t("Confirm New Password")}
                              onChange={(e) =>
                                setuppassword("password", e.target.value)
                              }
                              style={{ paddingRight: "40px" }}
                            />
                            <i
                              onClick={() =>
                                setShowpassword((state) => ({
                                  ...state,
                                  password: !showpassword?.password,
                                }))
                              }
                              className={`toggle-password fa-regular fa-fw ${
                                showpassword?.password
                                  ? "fa-eye"
                                  : "fa-eye-slash"
                              }`}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top:
                                  passvalidmessage?.password ||
                                  passvalidmessage?.matchpassword
                                    ? "50%"
                                    : "70%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                color: "rgb(189 189 185)",
                              }}
                            ></i>
                            {passvalidmessage?.password ||
                            passvalidmessage?.matchpassword ? (
                              <p className="p-0 text-danger">
                                {passvalidmessage?.password
                                  ? passvalidmessage?.password
                                  : passvalidmessage?.matchpassword}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="col-12">
                          <button
                            type="button"
                            className="btn bg_btn"
                            onClick={() => passwordvalid()}
                          >
                            {t("Update")}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="cardBox h-100">
                        <div className="row">
                          <div className="col-lg-6 col-md-6">
                            <h4 className="card_title">{t("Login history")}</h4>
                          </div>
                          <div className="col-lg-6 col-md-6"></div>
                          <div className="col-lg-12">
                            <div className="table-responsive">
                              <table className="table table-dark table-striped">
                                <thead>
                                  <tr>
                                    <th>{t("Date")}</th>
                                    <th>{t("IP")}</th>
                                    <th>{t("Device/OS")}</th>
                                    <th>{t("Browser")}</th>
                                    <th>{t("Country")}</th>
                                    {/* <th>City</th> */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {loadinglogin ? (
                                    <tr>
                                      <td
                                        colSpan="5"
                                        className="loaderparentpositaion"
                                      >
                                        <Commonloader show={true} />
                                      </td>
                                    </tr>
                                  ) : loginhistory?.length ? (
                                    loginhistory.map((result, key) => {
                                      return (
                                        <tr key={key}>
                                          <td>
                                            {formatDate(result?.last_activity)}
                                          </td>
                                          <td>
                                            {result?.ip_address
                                              ? result?.ip_address
                                              : "-"}
                                          </td>
                                          <td>
                                            {" "}
                                            {result?.os ? result?.os : "-"}
                                          </td>
                                          <td>
                                            {result?.browser
                                              ? result?.browser
                                              : "-"}
                                          </td>
                                          <td>
                                            {result?.country
                                              ? result?.country
                                              : "-"}
                                          </td>
                                          {/* <td>Jaipur</td> */}
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr className="no_data_table">
                                      <td colSpan={5} className="text-center">
                                        {t("No Data Found")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {/* <nav aria-label="Page navigation example">
                              <ul className="pagination justify-content-end">
                                <li className="page-item disabled">
                                  <Link
                                    className="page-link"
                                    to="" onClick={(e)=>e.preventDefault()}
                                    tabindex="-1"
                                    aria-disabled="true"
                                  >
                                    Previous
                                  </Link>
                                </li>
                                <li className="page-item active">
                                  <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                    1
                                  </Link>
                                </li>
                                <li className="page-item">
                                  <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                    2
                                  </Link>
                                </li>
                                <li className="page-item">
                                  <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                    3
                                  </Link>
                                </li>
                                <li className="page-item">
                                  <Link className="page-link" to="" onClick={(e)=>e.preventDefault()}>
                                    Next
                                  </Link>
                                </li>
                              </ul>
                            </nav> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="cardBox h-100">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="cardtitleWbtn">
                              <h4 className="card_title">
                                {t("Active sessions")}
                              </h4>
                              <button
                                type="button"
                                className="btn bg_btn"
                                onClick={() =>
                                  terminatsessions("all", loginsection)
                                }
                              >
                                {t("Terminate all")}
                              </button>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="table-responsive">
                              <table className="table table-dark table-striped">
                                <thead>
                                  <tr>
                                    <th>{t("Last activity")}</th>
                                    <th>{t("IP")}</th>
                                    <th>{t("Device/OS")}</th>
                                    <th>{t("Browser")}</th>
                                    <th>{t("Country")}</th>
                                    <th>{t("Action")}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {loadingactive ? (
                                    <tr>
                                      <td
                                        colSpan="6"
                                        className="loaderparentpositaion"
                                      >
                                        <Commonloader show={true} />
                                      </td>
                                    </tr>
                                  ) : loginsection?.length ? (
                                    loginsection.map((result, key) => {
                                      return (
                                        <tr key={key}>
                                          <td>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 24 24"
                                              width="12"
                                              height="12"
                                              fill="rgba(37,158,34,1)"
                                            >
                                              <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"></path>
                                            </svg>{" "}
                                            {formatDate(result?.last_activity)}
                                          </td>
                                          <td>
                                            {" "}
                                            {result?.ip_address
                                              ? result?.ip_address
                                              : "-"}
                                          </td>
                                          <td>
                                            {" "}
                                            {result?.os ? result?.os : "-"}
                                          </td>
                                          <td>
                                            {result?.browser
                                              ? result?.browser
                                              : "-"}
                                          </td>
                                          <td>
                                            {result?.country
                                              ? result?.country
                                              : "-"}
                                          </td>
                                          <td>
                                            <button
                                              type="button"
                                              class="btn badge bg-danger"
                                              onClick={() =>
                                                terminatsessions(
                                                  "single",
                                                  result?.token_id,
                                                )
                                              }
                                            >
                                              Terminate
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })
                                  ) : (
                                    <tr className="no_data_table">
                                      <td colSpan={6} className="text-center">
                                        {t("No Data Found")}
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            <Pagination
                              totalItems={totalPagesactive || 20}
                              itemsPerPage={itemsPerPageactive || 20}
                              currentPage={currentPageactive || 1}
                              goToPage={goToPageactive}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="cardBox mb-4">
                    <h4 className="card_title">
                      {t("Hotkeys")}{" "}
                      {activekeys ? t("[active]") : t("[Inactive]")}
                    </h4>
                    <div className="row">
                      <div className="col-lg-5 col-md-6">
                        <img src={hotkeys} className="hot-keys-img" alt="" />
                      </div>
                      <div className="col-lg-7 col-md-6">
                        <h5 className="modal-title mb-3">
                          {t("Configuration")}
                        </h5>
                        <ul className="hotkeys_option">
                          <li>
                            <h4 className="m-0">Shift + W</h4>
                            <p className="m-0">
                              {t("buy")} {t("(New trade)")}
                            </p>
                          </li>
                          <li>
                            <h4 className="m-0">Shift + S</h4>
                            <p className="m-0">
                              {t("sell")} {t("(New trade)")}
                            </p>
                          </li>
                          <li>
                            <h4 className="m-0">Shift + A</h4>
                            <p className="m-0">{t("Decrease trade amount")}</p>
                          </li>
                          <li>
                            <h4 className="m-0">Shift + D</h4>
                            <p className="m-0">{t("Increase trade amount")}</p>
                          </li>
                          <li>
                            <h4 className="m-0">Shift + TAB</h4>
                            <p className="m-0">{t("Next favorite asset")}</p>
                          </li>
                        </ul>

                        <div className="btnsGroup hotkeysactive mt-3">
                          {activekeys ? (
                            <Link
                              className="btn green_btn"
                              to=""
                              style={{
                                border: "1px solid #840808",
                                color: "#e52222",
                                fontWeight: 400,
                                // width: "fit-content",
                                boxShadow: "0 0 14px inset #e52222",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                hotkeysset(0);
                              }}
                            >
                              {t("Deactivate hotkeys")}
                            </Link>
                          ) : (
                            <Link
                              className="btn green_btn"
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                hotkeysset(1);
                              }}
                            >
                              {t("Activate hotkeys")}
                            </Link>
                          )}
                        </div>

                        <div className="search_options_Enable">
                          <div className="form-check form-switch form-switch-left pb-0 mb-0 mt-3">
                            <div className="check-input-div">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={searchpopup}
                                onChange={(e) =>
                                  searchprefrence(e.target.checked)
                                }
                              />
                            </div>
                            <label className="form-check-label">
                              {t("Type to search")}{" "}
                            </label>
                            <span className="btn p-0">
                              <span className="toolTip01">
                                Select trading pairs by just directly typing on
                                keyboard
                              </span>
                              <img src={info} alt="Information" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12 col-md-12 mb-4">
                      <div className="cardBox h-100">
                        <h4 className="card_title">
                          {t("Social Trading Settings")}
                        </h4>
                        <div className="socialTradingSeting">
                          {Object.keys(socialTradingSettings).map((key) => (
                            <div key={key} className="form-check form-switch">
                              <div className="check-input-div">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={!socialTradingSettings[key]}
                                  onChange={() => setupsocialsetting(key)}
                                />
                              </div>
                              <label className="form-check-label">
                                {settingLabels[key] || key}{" "}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="cardBox formCheckinput011 h-100">
                        <h4 className="card_title">{t("Sound control")}</h4>
                        <p class="fw-light fs-6 text-white">
                          {t(
                            "Use the sound control settings to enable or disable sound notification for your trading orders.",
                          )}
                        </p>

                        <Settings
                          text={"Sound Control"}
                          checked={soundEnabled}
                          setsettingprefrence={setsettingprefrence}
                          classNameicMode={classNameicMode}
                          showtooltip={showtooltip}
                          soundEnabled={soundEnabled}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="cardBox formCheckinput011 h-100">
                        <h4 className="card_title">{t("Tooltips")}</h4>
                        <p class="fw-light fs-6 text-white">
                          {t(
                            "Use the Tooltips control settings to enable or disable the trade order results rendering on the trading interface",
                          )}
                        </p>

                        <Settings
                          text={"Tooltips"}
                          checked={showtooltip}
                          setsettingprefrence={setsettingprefrence}
                          classNameicMode={classNameicMode}
                          showtooltip={showtooltip}
                          soundEnabled={soundEnabled}
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="cardBox h-100">
                        <h4 className="card_title">{t("Select Timezone")}</h4>
                        <form action="#" className="boxbg">
                          <label>{t("Timezone")}</label>
                          <TimezoneSelector
                            setUpdateTimezone={setUpdateTimezone}
                            updatetimezone={updatetimezone}
                          />
                        </form>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 mb-4">
                      <div className="cardBox h-100">
                        <h4 className="card_title">
                          {t("Select interface language")}
                        </h4>
                        <form action="#" className="boxbg">
                          <label>{t("Language")}</label>
                          <LanguageSelector />
                        </form>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-6 mb-4">
                      <div className="cardBox h-100">
                        <h4 className="card_title">
                          {t("Your Preferred Trading mode")}
                        </h4>
                        <div className="row">
                          <div className="col-lg-6 ">
                            <div
                              className={`cursor-pointer position-relative trading_mode_body boxbg mb-3 ${
                                classNameicMode && "active"
                              }`}
                              onClick={() =>
                                setsettingprefrence(
                                  true,
                                  soundEnabled,
                                  showtooltip,
                                )
                              }
                              style={{
                                border: classNameicMode
                                  ? "1px dashed #fff"
                                  : "1px dashed #0000",
                              }}
                            >
                              <div
                                className={`d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 ${
                                  !settingloader?.classic && "d-none"
                                }`}
                                style={{
                                  zIndex: 1,
                                  backgroundColor: "rgb(0 0 0)",
                                  borderRadius: "10px",
                                  height: "100%",
                                }}
                              >
                                <svg
                                  className="ajax-loader-v2__icon"
                                  width="64"
                                  height="64"
                                  xmlns="http://www.w3.org/2000/svg"
                                  shapeRendering="geometricPrecision"
                                  textRendering="geometricPrecision"
                                  viewBox="0 0 64 64"
                                  style={{ whiteSpace: "pre" }}
                                >
                                  <style>
                                    {`
                                 @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                 @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
                                 @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
                                 @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
                                 @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
                                 @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
                                 @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
                                 @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                 @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
                                 @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
                               `}
                                  </style>

                                  <rect
                                    width="2"
                                    height="37"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="19.5"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                                    }}
                                  />
                                  <rect
                                    width="2"
                                    height="42"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="21"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                                    }}
                                  />
                                  <rect
                                    width="2"
                                    height="28"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="16"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                                    }}
                                  />
                                  <rect
                                    width="2"
                                    height="40"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="23"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                                    }}
                                  />
                                </svg>
                              </div>
                              <div className="content-col">
                                <label>{t("Classic Mode")}</label>
                                <p>
                                  {t("Trade Using Two Buttons:")}{" "}
                                  <span>{t("“Buy” or “Sell”")}</span>
                                </p>
                              </div>
                              <div className="pop_btn">
                                <Link className="btn bg_btn butBtn" to="#">
                                  <img src={buyicon} alt="Buy" /> {t("Buy")}
                                </Link>
                                <Link className="btn bg_btn sellBtn" to="#">
                                  <img src={sellicon} alt="Sell" /> {t("Sell")}
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 ">
                            <div
                              onClick={() =>
                                setsettingprefrence(
                                  false,
                                  soundEnabled,
                                  showtooltip,
                                )
                              }
                              className={`cursor-pointer position-relative trading_mode_body boxbg ${
                                !classNameicMode && "active"
                              }`}
                              style={{
                                border: !classNameicMode
                                  ? "1px dashed #fff"
                                  : "1px dashed #0000",
                              }}
                            >
                              <div
                                className={`d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 ${
                                  !settingloader?.default && "d-none"
                                }`}
                                style={{
                                  zIndex: 1,
                                  backgroundColor: "rgb(0 0 0)",
                                  borderRadius: "10px",
                                  height: "100%",
                                }}
                              >
                                <svg
                                  className="ajax-loader-v2__icon"
                                  width="64"
                                  height="64"
                                  xmlns="http://www.w3.org/2000/svg"
                                  shapeRendering="geometricPrecision"
                                  textRendering="geometricPrecision"
                                  viewBox="0 0 64 64"
                                  style={{ whiteSpace: "pre" }}
                                >
                                  <style>
                                    {`
                                 @keyframes a21470_t { 0% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 84.2105% { transform: translate(55.5px,20.5px) scale(1,0.6) translate(-0.5px,-14px); } 100% { transform: translate(55.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                 @keyframes a21470_o { 0% { opacity: 0; } 84.2105% { opacity: 0; } 100% { opacity: 1; } }
                                 @keyframes a21471_t { 0% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 73.6842% { transform: translate(56px,29.5px) scale(1,0.052619) translate(-5px,-19.5px); } 89.4736% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } 100% { transform: translate(56px,29.5px) scale(1,1) translate(-5px,-19.5px); } }
                                 @keyframes a21471_o { 0% { opacity: 0; } 73.6842% { opacity: 0; } 89.4737% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21472_t { 0% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 68.421% { transform: translate(39.5px,20.5px) scale(1,0.5) translate(-0.5px,-5px); } 84.2105% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } 100% { transform: translate(39.5px,18px) scale(1,1) translate(-0.5px,-5px); } }
                                 @keyframes a21472_o { 0% { opacity: 0; } 68.4211% { opacity: 0; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21473_t { 0% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 57.8947% { transform: translate(40px,38px) scale(1,0.054423) translate(-5px,-21px); } 73.6842% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } 100% { transform: translate(40px,38px) scale(1,1) translate(-5px,-21px); } }
                                 @keyframes a21473_o { 0% { opacity: 0; } 57.8947% { opacity: 0; } 73.6842% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21474_t { 0% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 47.3684% { transform: translate(23.5px,20.5px) scale(1,0.4) translate(-0.5px,9px); } 63.1578% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } 100% { transform: translate(23.5px,18px) scale(1,1) translate(-0.5px,9px); } }
                                 @keyframes a21474_o { 0% { opacity: 0; } 47.3684% { opacity: 0; } 63.1579% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21475_t { 0% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 31.5789% { transform: translate(24px,47px) scale(1,0.082881) translate(-5px,-16px); } 47.3684% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } 100% { transform: translate(24px,47px) scale(1,1) translate(-5px,-16px); } }
                                 @keyframes a21475_o { 0% { opacity: 0; } 31.5789% { opacity: 0; } 47.3684% { opacity: 1; } 84.2105% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21476_t { 0% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 21.0526% { transform: translate(7.5px,25.5px) scale(1,0.7) translate(-0.5px,-14px); } 36.8421% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } 100% { transform: translate(7.5px,18px) scale(1,1) translate(-0.5px,-14px); } }
                                 @keyframes a21476_o { 0% { opacity: 0; } 21.0526% { opacity: 0; } 36.8421% { opacity: 1; } 100% { opacity: 1; } }
                                 @keyframes a21477_t { 0% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 5.2631% { transform: translate(8px,17px) scale(1,0.058969) translateX(-5px); } 21.0526% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } 100% { transform: translate(8px,17px) scale(1,1) translateX(-5px); } }
                                 @keyframes a21477_o { 0% { opacity: 0; } 5.2632% { opacity: 0; } 21.0526% { opacity: 1; } 100% { opacity: 1; } }
                               `}
                                  </style>

                                  <rect
                                    width="2"
                                    height="37"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(55.5,20.5) scale(1,0.6) translate(-0.5,-14)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21470_t, 1.9s linear infinite both a21470_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="19.5"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(56,29.5) scale(1,0.0526194) translate(-5,-19.5)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21471_t, 1.9s linear infinite both a21471_o",
                                    }}
                                  />
                                  <rect
                                    width="2"
                                    height="42"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(39.5,20.5) scale(1,0.5) translate(-0.5,-5)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21472_t, 1.9s linear infinite both a21472_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="21"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(40,38) scale(1,0.0544235) translate(-5,-21)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21473_t, 1.9s linear infinite both a21473_o",
                                    }}
                                  />
                                  <rect
                                    width="2"
                                    height="28"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(23.5,20.5) scale(1,0.4) translate(-0.5,9)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21474_t, 1.9s linear infinite both a21474_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="16"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(24,47) scale(1,0.0828809) translate(-5,-16)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21475_t, 1.9s linear infinite both a21475_o",
                                    }}
                                  />
                                  <rect
                                    width="2"
                                    height="40"
                                    fill="#fff"
                                    opacity="0"
                                    transform="translate(7.5,25.5) scale(1,0.7) translate(-0.5,-14)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21476_t, 1.9s linear infinite both a21476_o",
                                    }}
                                  />
                                  <rect
                                    width="10"
                                    height="23"
                                    fill="#fff"
                                    rx="1"
                                    opacity="0"
                                    transform="translate(8,17) scale(1,0.0589689) translate(-5,0)"
                                    style={{
                                      animation:
                                        "1.9s linear infinite both a21477_t, 1.9s linear infinite both a21477_o",
                                    }}
                                  />
                                </svg>
                              </div>
                              <div className="content-col">
                                <label>{t("Default Mode")}</label>
                                <p>
                                  {t("Trade Using Two Buttons:")}{" "}
                                  <span>{t("“Buy” or “Sell”")}</span>
                                </p>
                              </div>
                              <div className="defaultmode_btn pop_btn">
                                <Link
                                  className="btn bg_btn butBtn"
                                  to=""
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img src={buyicon} alt="Buy" /> {t("Buy")}
                                </Link>
                                <Link
                                  className="btn bg_btn sellBtn"
                                  to=""
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <img src={sellicon} alt="Sell" /> {t("Sell")}
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {userdata?.type === 2 ? (
                      <div className="col-lg-12 col-md-12 mb-4">
                        {/* <div className="row paymentGatewayopt"> */}

                        <div className="cardBox withdrawal_form">
                          <h4 class="card_title">Request Deposit</h4>
                          <from>
                            <div class="">
                              <label>
                                Amount <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="amount"
                                placeholder="Enter your Amount"
                                class="form-control"
                                value={value}
                                onChange={handleChange}
                                min="1"
                              />
                            </div>
                            <button
                              type="button"
                              class="btn bg-white"
                              onClick={() => dummydeposit(value)}
                            >
                              Submit
                            </button>
                          </from>
                        </div>
                      </div>
                    ) : (
                      // </div>
                      ""
                    )}
                    <div className="col-lg-12 col-md-12 mb-4">
                      <div
                        className="delete-account-btn"
                        style={{ maxWidth: "680px", margin: "0 auto" }}
                      >
                        <button
                          type="button"
                          style={{ border: "none" }}
                          class="btn bg-danger"
                          onClick={() => openModal("deletepopupmodal")}
                        >
                          Delete account
                        </button>
                      </div>
                    </div>
                    {/* <div className="col-lg-7 col-md-7 mb-4">
                      <div className="cardBox h-100">
                        <h4 className="card_title">Theme Settings</h4>
                        <div className="leftviewtabs">
                          <ul
                            className="nav nav-tabs"
                            id="myTab"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link active"
                                id="tradingmode-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#tradingmode"
                                type="button"
                                role="tab"
                                aria-controls="tradingmode"
                                aria-selected="true"
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M2 2V19C2 20.66 3.34 22 5 22H22"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M5 17L9.59 11.64C10.35 10.76 11.7 10.7 12.52 11.53L13.47 12.48C14.29 13.3 15.64 13.25 16.4 12.37L21 7"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>{" "}
                                Trading mode
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="Languages-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#Languages"
                                type="button"
                                role="tab"
                                aria-controls="Languages"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.3982 17H20.4564M13.3982 17L11.516 21M13.3982 17L16.2172 11.009C16.4444 10.5263 16.5579 10.2849 16.7133 10.2086C16.8485 10.1423 17.006 10.1423 17.1412 10.2086C17.2966 10.2849 17.4102 10.5263 17.6373 11.009L20.4564 17M20.4564 17L22.3386 21M2.66113 5H8.56436M8.56436 5H12.0079M8.56436 5V3M12.0079 5H14.4676M12.0079 5C11.5198 7.95729 10.3871 10.6362 8.72724 12.8844M10.5321 14C9.92945 13.7248 9.31471 13.3421 8.72724 12.8844M8.72724 12.8844C7.39652 11.8478 6.20579 10.4266 5.61275 9M8.72724 12.8844C7.14843 15.0229 5.09271 16.7718 2.66113 18"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>{" "}
                                Languages
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="soundcontrol-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#soundcontrol"
                                type="button"
                                role="tab"
                                aria-controls="soundcontrol"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M3.34961 8.25V15.75"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M7.9248 5.75V18.25"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M12.5 3.25V20.75"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M17.0752 5.75V18.25"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M21.6494 8.25V15.75"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>{" "}
                                Sound control
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="theme-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#theme"
                                type="button"
                                role="tab"
                                aria-controls="theme"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9.54823 22H15.4515C20.3708 22 22.3386 20 22.3386 15V9C22.3386 4 20.3708 2 15.4515 2H9.54823C4.62887 2 2.66113 4 2.66113 9V15C2.66113 20 4.62887 22 9.54823 22Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M12.5 2V22"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M2.66113 12H22.3386"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>{" "}
                                Theme
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="tooltips-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#tooltips"
                                type="button"
                                role="tab"
                                aria-controls="tooltips"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6 6L10.5 10.5M6 6H3L2 3L3 2L6 3V6ZM19.259 2.74101L16.6314 5.36863C16.2354 5.76465 16.0373 5.96265 15.9632 6.19098C15.8979 6.39183 15.8979 6.60817 15.9632 6.80902C16.0373 7.03735 16.2354 7.23535 16.6314 7.63137L16.8686 7.86863C17.2646 8.26465 17.4627 8.46265 17.691 8.53684C17.8918 8.6021 18.1082 8.6021 18.309 8.53684C18.5373 8.46265 18.7354 8.26465 19.1314 7.86863L21.5893 5.41072C21.854 6.05488 22 6.76039 22 7.5C22 10.5376 19.5376 13 16.5 13C16.1338 13 15.7759 12.9642 15.4298 12.8959C14.9436 12.8001 14.7005 12.7521 14.5532 12.7668C14.3965 12.7824 14.3193 12.8059 14.1805 12.8802C14.0499 12.9501 13.919 13.081 13.657 13.343L6.5 20.5C5.67157 21.3284 4.32843 21.3284 3.5 20.5C2.67157 19.6716 2.67157 18.3284 3.5 17.5L10.657 10.343C10.919 10.081 11.0499 9.95005 11.1198 9.81949C11.1941 9.68068 11.2176 9.60347 11.2332 9.44681C11.2479 9.29945 11.1999 9.05638 11.1041 8.57024C11.0358 8.22406 11 7.86621 11 7.5C11 4.46243 13.4624 2 16.5 2C17.5055 2 18.448 2.26982 19.259 2.74101ZM12.0001 14.9999L17.5 20.4999C18.3284 21.3283 19.6716 21.3283 20.5 20.4999C21.3284 19.6715 21.3284 18.3283 20.5 17.4999L15.9753 12.9753C15.655 12.945 15.3427 12.8872 15.0408 12.8043C14.6517 12.6975 14.2249 12.7751 13.9397 13.0603L12.0001 14.9999Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>{" "}
                                Tooltips
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="indicators-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#indicators"
                                type="button"
                                role="tab"
                                aria-controls="indicators"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.4353 2H8.56436C4.62887 2 2.66113 4 2.66113 8V21C2.66113 21.55 3.10387 22 3.645 22H16.4353C20.3708 22 22.3386 20 22.3386 16V8C22.3386 4 20.3708 2 16.4353 2Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M13.3955 7.83991L8.28919 13.0299C8.09241 13.2299 7.90549 13.6199 7.86613 13.8999L7.59065 15.8799C7.49226 16.5999 7.98419 17.0999 8.69258 16.9999L10.6406 16.7199C10.9161 16.6799 11.2998 16.4899 11.4966 16.2899L16.6029 11.0999C17.4786 10.2099 17.9016 9.16991 16.6029 7.84991C15.3042 6.51991 14.281 6.93991 13.3955 7.83991Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M12.667 8.57983C13.0999 10.1498 14.3101 11.3898 15.8646 11.8298"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>{" "}
                                Indicators
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="chart-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#chart"
                                type="button"
                                role="tab"
                                aria-controls="chart"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clip-path="url(#clip0_2619_1928)">
                                    <path
                                      d="M11.1273 9.29999C11.1273 9.67999 10.985 10.04 10.7512 10.3C10.4665 10.66 10.0293 10.88 9.52098 10.88C8.96181 10.88 8.48399 10.61 8.19932 10.19C8.01632 9.93999 7.9248 9.62998 7.9248 9.30998C7.9248 8.43998 8.63649 7.73999 9.53115 7.73999C10.4258 7.73999 11.1273 8.43998 11.1273 9.30998V9.29999Z"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M17.0746 14.6999C17.0746 15.5699 16.3629 16.2699 15.4682 16.2699C14.5736 16.2699 13.8721 15.5699 13.8721 14.6999C13.8721 14.3499 13.9941 14.0299 14.1974 13.7699C14.4821 13.3799 14.9396 13.1299 15.4784 13.1299C16.0173 13.1299 16.5154 13.3999 16.8001 13.8199C16.9831 14.0699 17.0746 14.3799 17.0746 14.6999V14.6999Z"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M14.0549 13.5799L10.8828 10.4199"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M21.6502 8.97998L17.0752 13.48"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M3.34961 15.0099L8.0466 10.3899"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                    <path
                                      d="M17.5829 3H7.41628C5.17032 3 3.34961 4.79086 3.34961 7V17C3.34961 19.2091 5.17032 21 7.41628 21H17.5829C19.8289 21 21.6496 19.2091 21.6496 17V7C21.6496 4.79086 19.8289 3 17.5829 3Z"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    ></path>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_2619_1928">
                                      <rect
                                        width="24.4"
                                        height="24"
                                        fill="white"
                                        transform="translate(0.299805)"
                                      ></rect>
                                    </clipPath>
                                  </defs>
                                </svg>{" "}
                                Chart
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="timezone-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#timezone"
                                type="button"
                                role="tab"
                                aria-controls="timezone"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M22.3386 12C22.3386 6.48 17.9308 2 12.4998 2C7.06887 2 2.66113 6.48 2.66113 12C2.66113 17.52 7.06887 22 12.4998 22"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M8.56442 3H9.54829C7.62974 8.84 7.62974 15.16 9.54829 21H8.56442"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M15.4512 3C16.4055 5.92 16.8876 8.96 16.8876 12"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M3.64551 16V15C6.51841 15.97 9.50938 16.46 12.5003 16.46"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M3.64551 9.0001C9.39131 7.0501 15.6094 7.0501 21.3552 9.0001"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M21.2139 17.74C21.2139 19.4604 19.8401 20.8566 18.1475 20.8566C16.4548 20.8566 15.0811 19.4604 15.0811 17.74C15.0811 16.0196 16.4548 14.6233 18.1475 14.6233C19.8401 14.6233 21.2139 16.0196 21.2139 17.74Z"
                                    stroke="white"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                  <path
                                    d="M19.2853 18.7311L18.3347 18.1545C18.1691 18.0547 18.0342 17.8148 18.0342 17.6184V16.3406"
                                    stroke="white"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  ></path>
                                </svg>{" "}
                                Timezone
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link"
                                id="islamicaccount-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#islamicaccount"
                                type="button"
                                role="tab"
                                aria-controls="islamicaccount"
                                aria-selected="false"
                                tabindex="-1"
                              >
                                <img src={islamicaccount} alt="" /> Islamic
                                account
                              </button>
                            </li>
                          </ul>
                          <div className="tab-content" id="myTabContent">
                            <div
                              className="tab-pane fade show active"
                              id="tradingmode"
                              role="tabpanel"
                              aria-labelledby="tradingmode-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Your Preferred Trading mode
                              </h5>
                              <div className="trading_mode_body boxbg mb-3">
                                <div className="content-col">
                                  <label>classNameic Mode</label>
                                  <p>
                                    Trade Using Two Buttons:{" "}
                                    <span>“Buy” or “Sell”</span>
                                  </p>
                                </div>
                                <div className="pop_btn">
                                  <Link className="btn bg_btn butBtn" to="" onClick={(e)=>e.preventDefault()}>
                                    <img src={buyicon} alt="Buy" /> Buy
                                  </Link>
                                  <Link className="btn bg_btn sellBtn" to="" onClick={(e)=>e.preventDefault()}>
                                    <img src={sellicon} alt="Sell" /> Sell
                                  </Link>
                                </div>
                              </div>
                              <div
                                className="trading_mode_body boxbg"
                                style={{ border: "1px dashed #fff" }}
                              >
                                <div className="content-col">
                                  <label>Default Mode</label>
                                  <p>
                                    Trade Using Two Buttons:{" "}
                                    <span>“Buy” or “Sell”</span>
                                  </p>
                                </div>
                                <div className="defaultmode_btn pop_btn">
                                  <Link className="btn bg_btn butBtn" to="" onClick={(e)=>e.preventDefault()}>
                                    <img src={buyicon} alt="Buy" /> Buy
                                  </Link>
                                  <Link className="btn bg_btn sellBtn" to="" onClick={(e)=>e.preventDefault()}>
                                    <img src={sellicon} alt="Sell" /> Sell
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="Languages"
                              role="tabpanel"
                              aria-labelledby="Languages-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Select interface language.
                              </h5>
                              <form action="#" className="boxbg">
                                <label>Languages</label>
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                >
                                  <option value="English" selected="">
                                    English
                                  </option>
                                  <option value="Hindi">Hindi</option>
                                  <option value="Arabic">Arabic</option>
                                  <option value="Tamil">Tamil</option>
                                </select>
                              </form>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="soundcontrol"
                              role="tabpanel"
                              aria-labelledby="soundcontrol-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Use the sound control settings to enable or
                                disable sound notification for your trading
                                orders.
                              </h5>
                              <div className="boxbg pb-0">
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked=""
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    Show Area
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked=""
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    Show Area
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="theme"
                              role="tabpanel"
                              aria-labelledby="theme-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Use the theme control settings to switch between
                                the light and dark themes of the website.
                              </h5>
                              <div
                                className="btn-group"
                                role="group"
                                aria-label="Basic mixed styles example"
                              >
                                <button
                                  type="button"
                                  className="btn btn-dark active"
                                >
                                  Light theme
                                </button>
                                <button type="button" className="btn btn-dark">
                                  Blue theme
                                </button>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="tooltips"
                              role="tabpanel"
                              aria-labelledby="tooltips-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Use the Tooltips control settings to enable or
                                disable the trade order results rendering on the
                                trading interface
                              </h5>
                              <div className="boxbg pb-0">
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked=""
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    Tooltips
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="indicators"
                              role="tabpanel"
                              aria-labelledby="indicators-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Use the indicators control settings to enable or
                                disable the appropriate indicator icon rendering
                                on the trading interface.
                              </h5>
                              <div className="boxbg pb-0">
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked=""
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    Signals
                                  </label>
                                </div>
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked=""
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    Analytics
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="chart"
                              role="tabpanel"
                              aria-labelledby="chart-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Use the chart settings to tune the rendering
                                preferences. The page will be reloaded
                                automatically.
                              </h5>
                              <div className="boxbg pb-0">
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked=""
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    Optimize chart
                                  </label>
                                </div>
                              </div>

                              <ul
                                className="nav nav-tabs horizTab"
                                id="myTab"
                                role="tablist"
                              >
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link active"
                                    id="candle-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#candle"
                                    type="button"
                                    role="tab"
                                    aria-controls="candle"
                                    aria-selected="true"
                                  >
                                    Candle
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="canvas-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#canvas"
                                    type="button"
                                    role="tab"
                                    aria-controls="canvas"
                                    aria-selected="false"
                                    tabindex="-1"
                                  >
                                    Canvas
                                  </button>
                                </li>
                              </ul>
                              <div
                                className="tab-content horizTabcontent"
                                id="myTabContent"
                              >
                                <div
                                  className="tab-pane fade show active"
                                  id="candle"
                                  role="tabpanel"
                                  aria-labelledby="candle-tab"
                                >
                                  <div className="form-check d-flex p-0 mb-3">
                                    <input
                                      className="check-form-input"
                                      type="checkbox"
                                      value=""
                                      id="colorBars"
                                    />
                                    <label
                                      className="check-form-label"
                                      for="colorBars"
                                    >
                                      Color Bars Based on previous Close
                                    </label>
                                  </div>

                                  <div className="colorOption">
                                    <div>
                                      <label>Body</label>
                                      <div className="inpuBox">
                                        <input
                                          type="color"
                                          id="favcolor"
                                          name="favcolor"
                                          value="#E95D50"
                                        />
                                        <input
                                          type="color"
                                          id="favcolor"
                                          name="favcolor"
                                          value="#8FF8FC"
                                        />
                                      </div>
                                    </div>
                                    <div>
                                      <label>Borders</label>
                                      <div className="inpuBox">
                                        <input
                                          type="color"
                                          id="favcolor"
                                          name="favcolor"
                                          value="#E95D50"
                                        />
                                        <input
                                          type="color"
                                          id="favcolor"
                                          name="favcolor"
                                          value="#8FF8FC"
                                        />
                                      </div>
                                    </div>
                                    <div>
                                      <label>Wick</label>
                                      <div className="inpuBox">
                                        <input
                                          type="color"
                                          id="favcolor"
                                          name="favcolor"
                                          value="#E95D50"
                                        />
                                        <input
                                          type="color"
                                          id="favcolor"
                                          name="favcolor"
                                          value="#8FF8FC"
                                        />
                                      </div>
                                    </div>
                                    <div>
                                      <label>Themes Shadow</label>
                                      <div className="inpuBox">
                                        <input
                                          type="color"
                                          id="favcolor"
                                          name="favcolor"
                                          value="#8FF8FC"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="canvas"
                                  role="tabpanel"
                                  aria-labelledby="canvas-tab"
                                >
                                  <div className="mboderbottom mb-3 pb-3">
                                    <h5 className="smalltitle p-0 mb-2">
                                      Chart Styles
                                    </h5>
                                    <div className="colorOption">
                                      <div>
                                        <label>Background</label>
                                        <div className="inpuBox">
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                          >
                                            <option value="Solid" selected="">
                                              Solid
                                            </option>
                                            <option value="Dashed">
                                              Dashed
                                            </option>
                                            <option value="Dotted">
                                              Dotted
                                            </option>
                                            <option value="Unset">Unset</option>
                                          </select>
                                          <input
                                            type="color"
                                            id="favcolor"
                                            name="favcolor"
                                            value="#8FF8FC"
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        <label>Grid Lines</label>
                                        <div className="inpuBox">
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                          >
                                            <option value="None" selected="">
                                              None
                                            </option>
                                            <option value="Block">Block</option>
                                          </select>
                                          <input
                                            type="color"
                                            id="favcolor"
                                            name="favcolor"
                                            value="#8FF8FC"
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        <label>Crosshair</label>
                                        <div className="inpuBox">
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                          >
                                            <option value="------" selected="">
                                              -------
                                            </option>
                                            <option value="......">
                                              .......
                                            </option>
                                            <option value="=======">
                                              =======
                                            </option>
                                          </select>
                                          <input
                                            type="color"
                                            id="favcolor"
                                            name="favcolor"
                                            value="#8FF8FC"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mboderbottom mb-3 pb-3">
                                    <h5 className="smalltitle p-0 mb-2 mt-3">
                                      Scales
                                    </h5>
                                    <div className="colorOption">
                                      <div>
                                        <label>Text</label>
                                        <div className="inpuBox">
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                          >
                                            <option value="10" selected="">
                                              10
                                            </option>
                                            <option value="12">12</option>
                                            <option value="14">14</option>
                                            <option value="16">16</option>
                                            <option value="18">18</option>
                                            <option value="20">20</option>
                                          </select>
                                          <input
                                            type="color"
                                            id="favcolor"
                                            name="favcolor"
                                            value="#8FF8FC"
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        <label>Lines</label>
                                        <div className="inpuBox">
                                          <input
                                            type="color"
                                            id="favcolor"
                                            name="favcolor"
                                            value="#0000"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mboderbottom mb-3 pb-3">
                                    <h5 className="smalltitle p-0 mb-2 mt-3">
                                      Scales
                                    </h5>
                                    <div className="selectinputOption">
                                      <div>
                                        <label>Navigation</label>
                                        <div className="selectOption">
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                          >
                                            <option
                                              value="Visible on Mouse Over"
                                              selected=""
                                            >
                                              Visible on Mouse Over
                                            </option>
                                            <option value="Hidden on Mouse Over">
                                              Hidden on Mouse Over
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                      <div>
                                        <label>Pane</label>
                                        <div className="selectOption">
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                          >
                                            <option
                                              value="Visible on Mouse Over"
                                              selected=""
                                            >
                                              Visible on Mouse Over
                                            </option>
                                            <option value="Hidden on Mouse Over">
                                              Hidden on Mouse Over
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="">
                                    <h5 className="smalltitle p-0 mb-2">
                                      Margins
                                    </h5>
                                    <div className="selectinputOption">
                                      <div>
                                        <label>Top</label>
                                        <div className="inputOption">
                                          <div className="input-group">
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="0"
                                              value="10%"
                                            />
                                            <span className="input-group-text">
                                              %
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <label>Bottom</label>
                                        <div className="inputOption">
                                          <div className="input-group">
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="0"
                                              value="8%"
                                            />
                                            <span className="input-group-text">
                                              %
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <label>Right</label>
                                        <div className="inputOption">
                                          <div className="input-group">
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="0"
                                              value="10%"
                                            />
                                            <span className="input-group-text">
                                              %
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="btngroup mt-3">
                                    <button
                                      type="button"
                                      className="btn grayBtn"
                                    >
                                      Cancel
                                    </button>
                                    <button type="button" className="btn bgBtn">
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="timezone"
                              role="tabpanel"
                              aria-labelledby="timezone-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Use the Timezone settings to set the desired
                                timezone for the charts and Platform in general.
                                Daily statements are still calculated by the
                                server time (UTC+2).
                                <span>Your location: Asia/Kolkata UTC+6</span>
                              </h5>
                              <form action="#" className="boxbg">
                                <label>Timezone</label>
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                >
                                  <option value="UTC +5:30" selected="">
                                    UTC +5:30
                                  </option>
                                  <option value="">...</option>
                                  <option value="">...</option>
                                  <option value="">...</option>
                                </select>
                              </form>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="islamicaccount"
                              role="tabpanel"
                              aria-labelledby="islamicaccount-tab"
                            >
                              <h5 className="smallwhitetitle">
                                Activating an Islamic halal account allows you
                                to trade on the platform in compliance with
                                Islamic finance principles.
                              </h5>
                              <div className="boxbg pb-0">
                                <div className="form-check form-switch">
                                  <div className="check-input-div">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked=""
                                    />
                                  </div>
                                  <label className="form-check-label">
                                    Islamic halal account
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div
          ref={(el) => (modalRefs.current["deletepopupmodal"] = el)}
          className="modal fade"
          id="deletepopupmodal"
          tabindex="-1"
          aria-labelledby="joinUsModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-body">
                <h5 className="modal-title">Delete account</h5>
                <button
                  onClick={() => setDeleteresion("")}
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                <p>
                  We are sorry that you decided to leave us. Please select the
                  reason why do you want to close your trading account:
                </p>
                <div className="dropdown realTrading_dt w-100 mw-100">
                  <CommonDropdown
                    label={deleteresion || "Select reason"}
                    options={deleteresiondata}
                    onSelect={(val) => setDeleteresion(val)}
                  />
                </div>

                <div className={`${!deleteresion && "d-none"}`}>
                  {deleteresion && reasonMessages[deleteresion]?.text && (
                    <div className="px-3 py-2 bg-dark my-2">
                      <p className="mb-0">
                        {reasonMessages[deleteresion]?.text
                          .split("{{support}}")
                          .map((part, index, arr) => (
                            <React.Fragment key={index}>
                              {part}
                              {index < arr.length - 1 && (
                                <Link
                                  onClick={handleSupportClick}
                                  data-bs-dismiss="modal"
                                  aria-label="Close"
                                  style={{ textDecoration: "none" }}
                                >
                                  Support Service
                                </Link>
                              )}
                            </React.Fragment>
                          ))}
                      </p>
                    </div>
                  )}
                  {deleteresion === "Other reason (Please specify)" ? (
                    <>
                      <textarea
                        className="from-control"
                        onChange={(e) => setDeleteresiontext(e.target.value)}
                      ></textarea>
                      {deletetext && (
                        <p className="text-danger">{deletetext}</p>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  <p>
                    If you still wish to close your account, confirm below. You
                    will be able to automatically restore your account within 30
                    days
                  </p>
                  <div className="delete-account-btn">
                    <button
                      type="button"
                      style={{ border: "none" }}
                      class="btn bg-danger"
                      onClick={() => setDeleteresion("")}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      style={{ border: "none" }}
                      class="btn bg-success"
                      onClick={() => deleteaccount(deleteresion)}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Setting;
